export var LOCAL_STORAGE_KEYS;
(function (LOCAL_STORAGE_KEYS) {
    LOCAL_STORAGE_KEYS["SELECTED_SPACE_ID"] = "SELECTED_SPACE_ID";
})(LOCAL_STORAGE_KEYS || (LOCAL_STORAGE_KEYS = {}));
